export interface createPageInfoArgs {
  currentPage: number
  lastPage: number
  perPage: number
  path: string
  from: number
  to: number
  total: number
}

export class PageInfo {
  currentPage: number
  lastPage: number
  perPage: number
  path: string
  from: number
  to: number
  total: number

  constructor(args: createPageInfoArgs) {
    this.currentPage = args.currentPage
    this.lastPage = args.lastPage
    this.perPage = args.perPage
    this.path = args.path
    this.from = args.from
    this.to = args.to
    this.total = args.total
  }
}
